import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { getApiErrorMessage, toApiError } from "../utils";

export const useDeleteManufacturer = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: string) => {
            try {
                return (await api.delete(`/manufacturer/delete/${id}`)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao deletar fabricante');
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['manufacturers'] });
        },
        onError: (error) => {
            console.error('Erro ao deletar fabricante:', getApiErrorMessage(error, 'Erro ao deletar fabricante'))
        },
    });
};
